import { render, staticRenderFns } from "./tagsSetting.vue?vue&type=template&id=5ff60468&scoped=true&"
import script from "./tagsSetting.vue?vue&type=script&lang=js&"
export * from "./tagsSetting.vue?vue&type=script&lang=js&"
import style0 from "./tagsSetting.vue?vue&type=style&index=0&id=5ff60468&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff60468",
  null
  
)

export default component.exports